import { absencesColumnsConfig } from './absences.columns.config'
import { absencesEntityConfig } from './absences.config'
import { colorDefinitionsColumnsConfig } from './colorDefinitions.columns.config'
import { colorDefinitionsEntityConfig } from './colorDefinitions.config'
import { contactCodesColumnsConfig } from './contactCodes.columns.config'
import { contactCodesEntityConfig } from './contactCodes.config'
import { contactCodeTreesColumnsConfig } from './contactCodeTrees.columns.config'
import { contactCodeTreesEntityConfig } from './contactCodeTrees.config'
import { customPagesColumnsConfig } from './customPages.columns.config'
import { customPagesEntityConfig } from './customPages.config'
import { customPropertiesColumnsConfig } from './customProperties.columns.config'
import { customPropertiesEntityConfig } from './customProperties.config'
import { pauseReasonsColumnsConfig } from './pauseReasons.columns.config'
import { pauseReasonsEntityConfig } from './pauseReasons.config'
import { permissionsColumnsConfig } from './permissions.columns.config'
import { permissionsEntityConfig } from './permissions.config'
import { queuesColumnsConfig } from './queues.columns.config'
import { queuesEntityConfig } from './queues.config'
import { rolesColumnsConfig } from './roles.columns.config'
import { rolesEntityConfig } from './roles.config'
import { ruleSetsColumnsConfig } from './ruleSets.columns.config'
import { ruleSetsEntityConfig } from './ruleSets.config'
import { settingsEntityConfig } from './settings.config'
import { skillGroupsColumnsConfig } from './skillGroups.columns.config'
import { skillGroupsEntityConfig } from './skillGroups.config'
import { skillsColumnsConfig } from './skills.columns.config'
import { skillsEntityConfig } from './skills.config'
import { teamsColumnsConfig } from './teams.columns.config'
import { teamsEntityConfig } from './teams.config'
import { templatesColumnsConfig } from './templates.columns.config'
import { templatesEntityConfig } from './templates.config'
import { userGroupsColumnsConfig } from './userGroups.columns.config'
import { userGroupsEntityConfig } from './userGroups.config'
import { usersColumnsConfig } from './users.columns.config'
import { usersEntityConfig } from './users.config'

export { absencesColumnsConfig } from './absences.columns.config'
export { absencesEntityConfig } from './absences.config'
export { absencesFormsConfig } from './absences.forms.config'
export { colorDefinitionsColumnsConfig } from './colorDefinitions.columns.config'
export { colorDefinitionsEntityConfig } from './colorDefinitions.config'
export { contactCodesColumnsConfig } from './contactCodes.columns.config'
export { contactCodesEntityConfig } from './contactCodes.config'
export { contactCodesFormsConfig } from './contactCodes.forms.config'
export { contactCodeTreesColumnsConfig } from './contactCodeTrees.columns.config'
export { contactCodeTreesEntityConfig } from './contactCodeTrees.config'
export { contactCodeTreesFormsConfig } from './contactCodeTrees.forms.config'
export { customPagesColumnsConfig } from './customPages.columns.config'
export { customPagesEntityConfig } from './customPages.config'
export { customPagesFormsConfig } from './customPages.forms.config'
export { customPropertiesColumnsConfig } from './customProperties.columns.config'
export { customPropertiesEntityConfig } from './customProperties.config'
export { customPropertiesFormsConfig } from './customProperties.forms.config'
export * from './entity-config.types'
export * from './entity-keys'
export { pauseReasonsColumnsConfig } from './pauseReasons.columns.config'
export { pauseReasonsEntityConfig } from './pauseReasons.config'
export { pauseReasonsFormsConfig } from './pauseReasons.forms.config'
export * from './permission-subjects'
export { permissionsColumnsConfig } from './permissions.columns.config'
export { permissionsEntityConfig } from './permissions.config'
export { queuesColumnsConfig } from './queues.columns.config'
export { queuesEntityConfig } from './queues.config'
export { queuesFormsConfig } from './queues.forms.config'
export { rolesColumnsConfig } from './roles.columns.config'
export { rolesEntityConfig } from './roles.config'
export { rolesFormsConfig } from './roles.forms.config'
export { ruleSetsColumnsConfig } from './ruleSets.columns.config'
export { ruleSetsEntityConfig } from './ruleSets.config'
export { ruleSetsFormsConfig } from './ruleSets.forms.config'
export { settingsEntityConfig } from './settings.config'
export { skillGroupsColumnsConfig } from './skillGroups.columns.config'
export { skillGroupsEntityConfig } from './skillGroups.config'
export { skillGroupsFormsConfig } from './skillGroups.forms.config'
export { skillsColumnsConfig } from './skills.columns.config'
export { skillsEntityConfig } from './skills.config'
export { skillsFormsConfig } from './skills.forms.config'
export { teamsColumnsConfig } from './teams.columns.config'
export { teamsEntityConfig } from './teams.config'
export { teamsFormsConfig } from './teams.forms.config'
export { templatesColumnsConfig } from './templates.columns.config'
export { templatesEntityConfig } from './templates.config'
export { templatesFormsConfig } from './templates.forms.config'
export { userGroupsColumnsConfig } from './userGroups.columns.config'
export { userGroupsEntityConfig } from './userGroups.config'
export { usersColumnsConfig } from './users.columns.config'
export { usersEntityConfig } from './users.config'
export { usersFormsConfig } from './users.forms.config'

export const EntityConfigs = {
	absences: absencesEntityConfig,
	colorDefinitions: colorDefinitionsEntityConfig,
	contactCodes: contactCodesEntityConfig,
	contactCodeTrees: contactCodeTreesEntityConfig,
	customPages: customPagesEntityConfig,
	customProperties: customPropertiesEntityConfig,
	pauseReasons: pauseReasonsEntityConfig,
	permissions: permissionsEntityConfig,
	queues: queuesEntityConfig,
	roles: rolesEntityConfig,
	ruleSets: ruleSetsEntityConfig,
	settings: settingsEntityConfig,
	skillGroups: skillGroupsEntityConfig,
	skills: skillsEntityConfig,
	teams: teamsEntityConfig,
	templates: templatesEntityConfig,
	userGroups: userGroupsEntityConfig,
	users: usersEntityConfig,
} as const

export function getEntityConfig<TKey extends keyof typeof EntityConfigs>(
	key: TKey,
): (typeof EntityConfigs)[TKey] {
	return EntityConfigs[key]
}

export const tableConfigs = {
	absences: absencesColumnsConfig,
	colorDefinitions: colorDefinitionsColumnsConfig,
	contactCodes: contactCodesColumnsConfig,
	contactCodeTrees: contactCodeTreesColumnsConfig,
	customPages: customPagesColumnsConfig,
	customProperties: customPropertiesColumnsConfig,
	pauseReasons: pauseReasonsColumnsConfig,
	permissions: permissionsColumnsConfig,
	queues: queuesColumnsConfig,
	roles: rolesColumnsConfig,
	ruleSets: ruleSetsColumnsConfig,
	skillGroups: skillGroupsColumnsConfig,
	skills: skillsColumnsConfig,
	teams: teamsColumnsConfig,
	templates: templatesColumnsConfig,
	userGroups: userGroupsColumnsConfig,
	users: usersColumnsConfig,
} as const

export type TableConfigMap = typeof tableConfigs
export type TableConfigKey = keyof TableConfigMap
export type RelationTableVariant = 'assigned' | 'available'

export type TableConfigOf<TKey extends TableConfigKey> = TableConfigMap[TKey]
export type EntityListTableConfig<TKey extends TableConfigKey> =
	TableConfigOf<TKey> extends { list: infer TList } ? TList : undefined
export type RelationTableKeys<TKey extends TableConfigKey> =
	TableConfigOf<TKey> extends { relations: infer TRelations }
		? keyof TRelations & string
		: never
export type RelationTableVariantKeys<
	TKey extends TableConfigKey,
	TRelationKey extends RelationTableKeys<TKey>,
> =
	TableConfigOf<TKey> extends { relations: infer TRelations }
		? TRelationKey extends keyof TRelations
			? keyof TRelations[TRelationKey] & RelationTableVariant
			: never
		: never
export type RelationTableConfig<
	TKey extends TableConfigKey,
	TRelationKey extends RelationTableKeys<TKey>,
	TVariant extends RelationTableVariantKeys<TKey, TRelationKey>,
> =
	TableConfigOf<TKey> extends { relations: infer TRelations }
		? TRelationKey extends keyof TRelations
			? TVariant extends keyof TRelations[TRelationKey]
				? TRelations[TRelationKey][TVariant]
				: undefined
			: undefined
		: undefined
export type ClientTableKeys<TKey extends TableConfigKey> =
	TableConfigOf<TKey> extends { client: infer TClient }
		? keyof TClient & string
		: never
export type ClientTableConfig<
	TKey extends TableConfigKey,
	TClientKey extends ClientTableKeys<TKey>,
> =
	TableConfigOf<TKey> extends { client: infer TClient }
		? TClientKey extends keyof TClient
			? TClient[TClientKey]
			: undefined
		: undefined

export function hasTableConfig(key: string): key is TableConfigKey {
	return key in tableConfigs
}

export function getTableConfig<TKey extends TableConfigKey>(
	key: TKey,
): TableConfigOf<TKey> {
	return tableConfigs[key]
}

export function getEntityListTableConfig<TKey extends TableConfigKey>(
	key: TKey,
): EntityListTableConfig<TKey> {
	const config = tableConfigs[key] as TableConfigOf<TKey>
	return (
		'list' in config ? config.list : undefined
	) as EntityListTableConfig<TKey>
}

export function getRelationTableConfig<
	TKey extends TableConfigKey,
	TRelationKey extends RelationTableKeys<TKey>,
	TVariant extends RelationTableVariantKeys<TKey, TRelationKey>,
>(
	key: TKey,
	relationKey: TRelationKey,
	variant: TVariant,
): RelationTableConfig<TKey, TRelationKey, TVariant> | undefined {
	const config = tableConfigs[key] as TableConfigOf<TKey>
	if (!('relations' in config)) return undefined
	const relations = config.relations as Record<
		string,
		Partial<Record<RelationTableVariant, unknown>>
	>
	return relations[relationKey]?.[variant]
}

export function getClientTableConfig<
	TKey extends TableConfigKey,
	TClientKey extends ClientTableKeys<TKey>,
>(
	key: TKey,
	clientKey: TClientKey,
): ClientTableConfig<TKey, TClientKey> | undefined {
	const config = tableConfigs[key] as TableConfigOf<TKey>
	if (!('client' in config)) return undefined
	const client = config.client as Record<string, unknown>
	return client[clientKey] as ClientTableConfig<TKey, TClientKey>
}

export type TableListRef<TKey extends TableConfigKey = TableConfigKey> =
	| { kind: 'list' }
	| {
			kind: 'relation'
			relationKey: RelationTableKeys<TKey>
			variant: RelationTableVariant
	  }
	| { kind: 'client'; clientKey: ClientTableKeys<TKey> }

export type AnyTableListRef =
	| { kind: 'list' }
	| { kind: 'relation'; relationKey: string; variant: RelationTableVariant }
	| { kind: 'client'; clientKey: string }

export function getTableListConfig<TKey extends TableConfigKey>(
	key: TKey,
	ref: { kind: 'list' },
): EntityListTableConfig<TKey>
export function getTableListConfig<
	TKey extends TableConfigKey,
	TRelationKey extends RelationTableKeys<TKey>,
	TVariant extends RelationTableVariantKeys<TKey, TRelationKey>,
>(
	key: TKey,
	ref: { kind: 'relation'; relationKey: TRelationKey; variant: TVariant },
): RelationTableConfig<TKey, TRelationKey, TVariant> | undefined
export function getTableListConfig<
	TKey extends TableConfigKey,
	TClientKey extends ClientTableKeys<TKey>,
>(
	key: TKey,
	ref: { kind: 'client'; clientKey: TClientKey },
): ClientTableConfig<TKey, TClientKey>
export function getTableListConfig(
	key: TableConfigKey,
	ref: AnyTableListRef,
): unknown {
	const config = tableConfigs[key]
	if (ref.kind === 'list') {
		return 'list' in config ? config.list : undefined
	}
	if (ref.kind === 'relation') {
		if (!('relations' in config)) return undefined
		const relations = config.relations as Record<
			string,
			Partial<Record<RelationTableVariant, unknown>>
		>
		return relations[ref.relationKey]?.[ref.variant]
	}
	if (!('client' in config)) return undefined
	const client = config.client as Record<string, unknown>
	return client[ref.clientKey]
}
